module.exports = __webpack_public_path__ + "img/win-2.a09ffed8.webp";